module.exports = __webpack_public_path__ + "static/media/w (19).90b3f42c.jpg";